import React from 'react';
interface DateSeparatorProps {
  date: string;
}
export const DateSeparator: React.FC<DateSeparatorProps> = ({
  date
}) => {
  return <div className="flex justify-center my-4 py-[8px]">
      <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-3 py-1">
        <span className="text-xs text-white/70 font-medium">
          {date}
        </span>
      </div>
    </div>;
};